// tempexp_18907-full-file
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { DiscountInOutflowSaveModalProps } from './DiscountInOutflowSaveModal';

export const renderDiscountInOutflowSaveModal = ({ onClose, ...data }: DiscountInOutflowSaveModalProps & { onClose?: () => void }) =>
    openPopupHelper({ popupName: popupNames.DISCOUNT_AFTER_OUTFLOW_MODAL, data, onClose });

export const closeDiscountInOutflowSaveModal = () => closePopupHelper(popupNames.DISCOUNT_AFTER_OUTFLOW_MODAL);
